import NotFooterLayout from "layouts/NotFooterLayout";
import Setting from "components/SettingManage";

function SettingPage() {
//  const dispatch = useAppDispatch();

  //show footer
 // dispatch(setFooterShow(true));
  return (
    <>
     {/* footerComponent={<FooterCreateOrder />} */}
      <NotFooterLayout namePage="ตั้งค่าร้านค้า"   >
        <div className="layout-content">
          <Setting  />
        </div>
      </NotFooterLayout>
    </>
  );
}

export default SettingPage;